import { Injectable, signal } from '@angular/core';

import { ErrorService } from 'src/lib/lib-ngx/services/error.service';
import { ApiService } from 'src/lib/lib-ngx/web-services/api.service';
import { AuthService } from 'src/lib/lib-ngx/web-services/auth.service';
import { TUserGetLavandierRep } from 'src/lib/lib-shared/api/client/User.Type';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  readonly contact = signal<TUserGetLavandierRep | undefined>(undefined);

  private loading = false;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private errorService: ErrorService
  ) {
    this.authService.logout$.subscribe(() => this.reset());
  }

  load() {
    if (
      !this.authService.isLoggedIn() ||
      this.loading ||
      this.contact() !== undefined
    ) {
      return;
    }
    this.loading = true;
    this.apiService.getUserLavandier({}).subscribe({
      next: (contact) => {
        this.loading = false;
        if (this.errorService.manageError(contact)) {
          return;
        }
        this.contact.set(contact);
      },
      error: (err) => {
        this.loading = false;
        this.errorService.manageError(err);
      },
    });
  }

  reset() {
    this.loading = false;
    this.contact.set(undefined);
  }
}
